import { capitalize, startCase } from 'lodash-es';

import { TransformationType } from '../../../types/transformation';
import { RawWorkflow, Workflow } from '../../../types/workflow';

import { ApiMapper, mapToApiModeTypes } from './types';

export const formatWorkflowTypeString = (workflowTypeString: string) => {
  // Can use a mapper here in the future

  return startCase(workflowTypeString.toLowerCase());
}

const workflowMapper: ApiMapper<RawWorkflow, Workflow> = {
  mapFromApi: (workflow) => {
    // We get the first element from the `enclaveDestinationConfigs` array because at the moment
    // the workflows only have one destination.
    const workflowDestination = workflow.workflowConfig.workflowDestination.enclaveDestinationConfigs[0];

    return {
      guid: workflow.guid,
      name: workflow.name,
      createdAt: workflow.created,
      updatedAt: workflow.updated,
      type: workflow.workflowConfig.type,
      sources: workflow.workflowConfig.workflowSource.enclaveSourceConfig.map(({ enclaveGuid, weight }) => ({
        weight,
        id: enclaveGuid,
      })),
      transformations: {
        [TransformationType.SCORE_FILTERING]: workflow.workflowConfig.priorityScores.map(capitalize),
        [TransformationType.INDICATOR_TYPE]: workflow.workflowConfig.observableTypes,
        [TransformationType.SAFELIST_LIBRARY]: workflow.safelistGuids,
      },
      destination: {
        guid: workflowDestination.enclaveGuid,
        type: workflowDestination.destinationType,
      },
      isNew: false,
    };
  },
  mapToApi: (workflow, mode) => {
    const sourceEnclaveConfig = workflow.sources.map((source) => ({
      enclaveGuid: source.id,
      weight: source.weight,
    }));

    // TODO Split Create and Update Behavior based on their required payloads
    return {
      name: workflow.name,
      safelistGuids: workflow.transformations.SAFELIST_LIBRARY || [],
      workflowConfig: {
        type: workflow.type,
        workflowSource: {
          enclaveSourceConfig: sourceEnclaveConfig,
        },
        workflowDestination: {
          enclaveDestinationConfigs: [{
            enclaveGuid: workflow.destination.guid,
            destinationType: workflow.destination.type,
          }],
        },
        priorityScores: workflow.transformations.SCORE_FILTERING!.map((value) => value.toUpperCase()),
        observableTypes: workflow.transformations.INDICATOR_TYPE!.map((value) => value.toUpperCase()),
      },
    };
  },
};

export default workflowMapper;
